<template>
  <div class="lesson_bottom">
    <p v-if="bottem_mes.order_status == 1" class="tips">已存在待支付订单，请直接支付</p>
    <div class="l_box">
      <h3>¥{{bottem_mes.salePrice}}</h3>
      <span>¥{{bottem_mes.originalPrice}}</span>
      <span>还剩{{bottem_mes.stockCount}}个名额</span>
    </div>
    <div v-if="bottem_mes.order_status == 0" class="r_box pay" @click="pay_event">立即报名</div>
    <div v-else-if="bottem_mes.order_status == 2" class="r_box payed" @click="pay_event">已购买</div>
    <div v-else-if="bottem_mes.order_status == 1" @click="pay_event" class="r_box pay">去支付</div>
  </div>
</template>

<script>
export default {
  name: "lessonBottom",
  props: ["bottem_mes"],
  data() {
    return {
      btn_click: ""
    };
  },
  watch: {
    bottem_mes(newName, oldName) {
      this.btn_click = newName.btn_status;
    }
  },
  methods: {
    pay_event: function() {
      if (!this.bottem_mes.btn_status) return;
      this.$emit("pay_event");
    }
  },
  created: function() {
    this.btn_click = this.bottem_mes.btn_status;
  }
};
</script>

<style lang="scss" scoped>
.lesson_bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  .tips {
    height: 0.6rem;
    font-family: PingFangSC-Medium;
    font-size: 0.26rem;
    line-height: 0.6rem;
    color: #ffffff;
    background-color: #000000;
    opacity: 0.7;
    text-align: center;
  }
  .l_box {
    float: left;
    padding: 0.25rem 0;
    width: 4.3rem;
    height: 1.1rem;
    background: #f8f2ea;
    h3 {
      display: inline-block;
      margin-left: 0.5rem;
      margin-right: 0.35rem;
      font-family: PingFangSC-Medium;
      font-size: 0.46rem;
      color: #ff714c;
      float: left;
      line-height: 0.6rem;
    }
    span {
      display: block;
      text-decoration: line-through;
      font-family: PingFangSC-Regular;
      font-size: 0.28rem;
      color: #b0b2c0;
      line-height: 0.35rem;
      &:last-child {
        font-family: PingFangSC-Medium;
        font-size: 0.24rem;
        color: #9796a4;
        text-decoration: none;
      }
    }
  }
  .pay {
    background: #f5833d;
  }
  .payed {
    background: #e7be85;
  }
  .r_box {
    height: 1.1rem;
    line-height: 1.1rem;
    font-family: PingFangSC-Medium;
    font-size: 0.38rem;
    color: #fff;
    text-align: center;
  }
}
</style>